import { render, staticRenderFns } from "./Macchine.vue?vue&type=template&id=01cd0130&scoped=true&"
import script from "./Macchine.vue?vue&type=script&lang=js&"
export * from "./Macchine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd0130",
  null
  
)

export default component.exports